// extracted by mini-css-extract-plugin
export default {"header":"RegistrationHeader_header__YLrDE"};